import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LocalStorage} from "ngx-webstorage";
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

import { MatOption } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-filter-pager',
    templateUrl: './filter-pager.component.html',
    styleUrls: ['./filter-pager.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatHint, TranslateModule]
})
export class FilterPagerComponent implements OnInit {

    public resultList = [10, 20, 30, 50, 100];
    public pageList = [];
    public resultsValue = 30;
    public pageValue = 1;
    public totalItems = 0;
    @LocalStorage('GLOBAL_item_par_page') public pagesize;

    @Input('totalItems') set field(totalItems: number) {
        this.totalItems = totalItems;
        this.calcPageNumber();
    }

    @Input('currentPage') set page(page: number) {
        this.pageValue = page;
    }

    @Output() changeSelection = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
        if(!this.pagesize) {
            this.pagesize = 30;
        }
        this.resultsValue = this.pagesize;
    }

    public updateResults() {
        this.pageValue = 1;
        this.calcPageNumber();
    }

    public updatePage() {
        this.pagesize = this.resultsValue;
        this.changeSelection.emit({page: this.pageValue, pageResults: this.resultsValue});
    }

    private calcPageNumber() {
        this.pageList = [];
        const nbPage = Math.ceil(this.totalItems / this.resultsValue);
        if (nbPage == 0) {
            this.pageList.push(1);
        }
        for (let i = 1; i <= nbPage; i++) {
            this.pageList.push(i);
        }
    }

}
